import React from 'react';
import { Link } from 'react-router-dom';
import './BrandBar.scss';

function BrandBar({ isLoggedIn, handleLogin, handleLogout, authEnabled = true, onMenuToggle, sidebarOpen }) {
  return (
    <div className="brand-bar">
      {!authEnabled && (
        <div className="auth-disabled-banner">
          🔧 DEV MODE: Authentication disabled
        </div>
      )}
      <button
        className="brandbar-menu-btn"
        onClick={onMenuToggle}
        aria-label={sidebarOpen ? 'Close menu' : 'Open menu'}
      >
        {sidebarOpen ? (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="22" height="22">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="22" height="22">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        )}
      </button>
      <div>
        {isLoggedIn ? (
          <button className="brandbar-btn-secondary" onClick={handleLogout}>Logout</button>
        ) : (
          <button className="brandbar-btn-secondary" onClick={handleLogin}>Login with Microsoft</button>
        )}
      </div>
    </div>
  );
}

export default BrandBar;
